import { Suspense } from 'react'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { LoaderRemover } from '@/components/loader-remover'
import { ImportJobMonitor } from '@/components/ImportJobMonitor'
import { Toaster } from '@/components/ui/sonner'
import GeneralError from '@/pages/errors/general-error'
import NotFoundError from '@/pages/errors/not-found-error'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router'
import { AdminModeProvider } from '@/context/AdminModeContext'
import { Agentation } from 'agentation'

// import { TanStackRouterDevtools } from '@tanstack/router-devtools'

export const Route = createRootRoute({
  component: () => {
    return (
      <NuqsAdapter>
        <AdminModeProvider>
          <Suspense
            fallback={
              <div className='flex h-screen w-screen items-center justify-center'>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='black'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  className='animate-spin'
                >
                  <circle cx='12' cy='12' r='10' strokeOpacity='0.25' />
                  <path d='M12 2a10 10 0 0 1 10 10' />
                </svg>
              </div>
            }
          >
            <Outlet />
            <LoaderRemover />
            <ImportJobMonitor />
            <Toaster position='top-center' />
            {import.meta.env.DEV && <Agentation />}
            {/* {import.meta.env.MODE === 'development' && (
              <>
                <ReactQueryDevtools buttonPosition='bottom-left' />
                <TanStackRouterDevtools position='bottom-right' />
              </>
            )} */}
          </Suspense>
        </AdminModeProvider>
      </NuqsAdapter>
    )
  },
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
})
